import { h } from 'preact'
import { useEffect, useRef } from 'preact/hooks'
import PropTypes from 'prop-types'

export default function AudioPlayer({ track }) {
  const audioRef = useRef(null)

  useEffect(() => {
    const el = audioRef.current
    if (!el || !track) return
    track.attach(el)
    return () => { track.detach(el) }
  }, [track])

  if (!track) return null

  return <audio ref={audioRef} autoPlay playsInline />
}

AudioPlayer.propTypes = {
  track: PropTypes.object,
}
